import React, { useCallback } from 'react';

import { Box, Stack } from '@atlaskit/primitives';

import { AiSubFooter } from './AiSubFooter';
import { BulkCreateNavigationHeader } from './BulkCreateNavigationHeader';
import {
	useAiBulkNavigationCurrentPage,
	useAiBulkNavigationGotoPage,
} from './AiBulkNavigationContextProvider';
import { SidePanel } from '@confluence/side-panel';

type BulkEditIssueViewProps = {
	isAiIssue?: boolean;
};

// This is the view for both AI and non-AI bulk create where users can edit and create individual issues
export const BulkEditIssueView = ({ isAiIssue = false }: BulkEditIssueViewProps) => {
	const goToPage = useAiBulkNavigationGotoPage();
	const currentPage = useAiBulkNavigationCurrentPage();

	const onClose = useCallback(() => void goToPage('default'), [goToPage]);
	const isOpen = currentPage === 'edit_issue';

	return (
		<SidePanel isOpen={isOpen}>
			<Stack>
				<BulkCreateNavigationHeader onClose={onClose} />
				<Box>GICanywhere Component goes here</Box>
				{isAiIssue && <AiSubFooter />}
			</Stack>
		</SidePanel>
	);
};
